export default __webpack_public_path__ + "static/media/ic-pdf.f21b6a1d.svg";